/**
 * Analytics Tracking Utility
 * Tracks user behavior and site usage for analytics dashboard
 */

import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Track an analytics event
 * @param {string} eventType - Type of event (page_view, session_start, session_complete, feature_use)
 * @param {object} data - Additional data for the event
 */
export const trackEvent = async (eventType, data = {}) => {
  try {
    const eventData = {
      event_type: eventType,
      page_path: data.page_path || window.location.pathname,
      user_id: data.user_id || null,
      session_id: data.session_id || null,
      metadata: data.metadata || {}
    };
    
    await axios.post(`${BACKEND_URL}/api/analytics/track`, eventData);
  } catch (error) {
    // Silently fail - don't disrupt user experience for analytics
    console.debug('Analytics tracking failed:', error);
  }
};

/**
 * Track a page view
 * @param {string} pagePath - The page path being viewed
 */
export const trackPageView = (pagePath) => {
  trackEvent('page_view', { page_path: pagePath });
};

/**
 * Track session start
 * @param {string} sessionId - The IF session ID
 */
export const trackSessionStart = (sessionId) => {
  trackEvent('session_start', { 
    session_id: sessionId,
    metadata: { action: 'start' }
  });
};

/**
 * Track session completion
 * @param {string} sessionId - The IF session ID
 * @param {object} metadata - Additional completion data (OI score, spark %, etc.)
 */
export const trackSessionComplete = (sessionId, metadata = {}) => {
  trackEvent('session_complete', { 
    session_id: sessionId,
    metadata
  });
};

/**
 * Track feature usage
 * @param {string} featureName - Name of the feature used
 * @param {object} metadata - Additional feature data
 */
export const trackFeatureUse = (featureName, metadata = {}) => {
  trackEvent('feature_use', {
    metadata: {
      feature: featureName,
      ...metadata
    }
  });
};
